export class TooltipPosition {

    private top: number;
    private left: number;

    private readonly bottom: number;
    private readonly right: number;
    private readonly height: number;
    private readonly width: number;

    constructor(event: CustomEvent, rect: ClientRect | DOMRect) {
        this.top = this.getCenterFor(event.detail.event.clientY, rect.height);
        this.bottom = this.top + rect.height;

        this.left = this.getCenterFor(event.detail.event.clientX, rect.width);
        this.right = this.left + rect.width;

        this.height = rect.height;
        this.width = rect.width;

        this.calculateTooltipPosition();
    }

    public getLeftPosition(): string {
        return `${ this.left }px`
    }

    public getTopPosition(): string {
        return `${ this.top }px`
    }

    private calculateTooltipPosition(): void {
        if (this.isOutOfBounds()) {
            if (this.bottom > window.innerHeight) {
                this.top = window.innerHeight - this.height;
            }

            if (this.right > window.innerWidth) {
                this.left = window.innerWidth - this.width;
            }
        }

        this.handleNegativeValues();
    }

    private isOutOfBounds(): boolean {
        return this.bottom > window.innerHeight || this.right > window.innerWidth;
    }

    private handleNegativeValues(): void {
        if (this.top < 0) {
            this.top = 0;
        }

        if (this.left < 0) {
            this.left = 0;
        }
    }

    private getCenterFor(dimension: number, delta: number): number {
        return dimension - delta / 2;
    }

}
